export const productCategories = [
    {
        slug: "towels",
        nameKey: "products.categories.towels.name",
        taglineKey: "products.categories.towels.tagline",
        descriptionKey: "products.categories.towels.description",
        image: "https://images.unsplash.com/photo-1631015108968-ba3b87f89005?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMHRvd2VscyUyMHN0YWNrJTIwaG90ZWx8ZW58MHx8fHwxNzgzNjg2NTY2fDA&ixlib=rb-4.1.0&q=85",
        galleryImages: [
            "https://images.unsplash.com/photo-1631015108968-ba3b87f89005?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMHRvd2VscyUyMHN0YWNrJTIwaG90ZWx8ZW58MHx8fHwxNzgzNjg2NTY2fDA&ixlib=rb-4.1.0&q=85",
            "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80",
            "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1200&q=80",
            "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80",
        ],
        subCategories: [
            "products.categories.towels.subCategories.hotel",
            "products.categories.towels.subCategories.spa",
            "products.categories.towels.subCategories.salon",
            "products.categories.towels.subCategories.gym",
            "products.categories.towels.subCategories.hospital",
            "products.categories.towels.subCategories.kitchen",
            "products.categories.towels.subCategories.beach",
            "products.categories.towels.subCategories.face",
            "products.categories.towels.subCategories.hand",
            "products.categories.towels.subCategories.pool",
            "products.categories.towels.subCategories.golf",
            "products.categories.towels.subCategories.baby",
            "products.categories.towels.subCategories.promotional",
        ],
        specs: [
            { labelKey: "products.categories.towels.specs.material.label", valueKey: "products.categories.towels.specs.material.value" },
            { labelKey: "products.categories.towels.specs.gsm.label", valueKey: "products.categories.towels.specs.gsm.value" },
            { labelKey: "products.categories.towels.specs.sizes.label", valueKey: "products.categories.towels.specs.sizes.value" },
            { labelKey: "products.categories.towels.specs.colors.label", valueKey: "products.categories.towels.specs.colors.value" },
            { labelKey: "products.categories.towels.specs.packaging.label", valueKey: "products.categories.towels.specs.packaging.value" },
            { labelKey: "products.categories.towels.specs.moq.label", valueKey: "products.categories.towels.specs.moq.value" },
            { labelKey: "products.categories.towels.specs.leadTime.label", valueKey: "products.categories.towels.specs.leadTime.value" },
            { labelKey: "products.categories.towels.specs.certifications.label", valueKey: "products.categories.towels.specs.certifications.value" },
        ],
        oem: true,
        privateLabel: true,
    },
    {
        slug: "home-textiles",
        nameKey: "products.categories.homeTextiles.name",
        taglineKey: "products.categories.homeTextiles.tagline",
        descriptionKey: "products.categories.homeTextiles.description",
        image: "https://images.unsplash.com/photo-1625471592808-3b848a6e9ffd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwaG9tZSUyMHRleHRpbGVzJTIwc3RhY2tlZHxlbnwwfHx8fDE3ODM2ODY1NTd8MA&ixlib=rb-4.1.0&q=85",
        galleryImages: [
            "https://images.unsplash.com/photo-1625471592808-3b848a6e9ffd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwaG9tZSUyMHRleHRpbGVzJTIwc3RhY2tlZHxlbnwwfHx8fDE3ODM2ODY1NTd8MA&ixlib=rb-4.1.0&q=85",
            "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1200&q=80",
            "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1200&q=80",
            "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1200&q=80",
        ],
        subCategories: [
            "products.categories.homeTextiles.subCategories.bedsheets",
            "products.categories.homeTextiles.subCategories.pillowCovers",
            "products.categories.homeTextiles.subCategories.cushionCovers",
            "products.categories.homeTextiles.subCategories.curtains",
            "products.categories.homeTextiles.subCategories.blankets",
            "products.categories.homeTextiles.subCategories.comforters",
            "products.categories.homeTextiles.subCategories.quilts",
            "products.categories.homeTextiles.subCategories.mattressProtectors",
            "products.categories.homeTextiles.subCategories.tableLinen",
            "products.categories.homeTextiles.subCategories.diningLinen",
            "products.categories.homeTextiles.subCategories.kitchenLinen",
            "products.categories.homeTextiles.subCategories.bathLinen",
        ],
        specs: [
            { labelKey: "products.categories.homeTextiles.specs.material.label", valueKey: "products.categories.homeTextiles.specs.material.value" },
            { labelKey: "products.categories.homeTextiles.specs.weave.label", valueKey: "products.categories.homeTextiles.specs.weave.value" },
            { labelKey: "products.categories.homeTextiles.specs.sizes.label", valueKey: "products.categories.homeTextiles.specs.sizes.value" },
            { labelKey: "products.categories.homeTextiles.specs.moq.label", valueKey: "products.categories.homeTextiles.specs.moq.value" },
            { labelKey: "products.categories.homeTextiles.specs.leadTime.label", valueKey: "products.categories.homeTextiles.specs.leadTime.value" },
            { labelKey: "products.categories.homeTextiles.specs.certifications.label", valueKey: "products.categories.homeTextiles.specs.certifications.value" },
        ],
        oem: true,
        privateLabel: true,
    },
    {
        slug: "rugs-carpets",
        nameKey: "products.categories.rugs.name",
        taglineKey: "products.categories.rugs.tagline",
        descriptionKey: "products.categories.rugs.description",
        image: "https://images.unsplash.com/photo-1773842298512-e49c9331cc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxoYW5kbWFkZSUyMHJ1Z3MlMjB3b3Jrc2hvcCUyMGFydGlzYW58ZW58MHx8fHwxNzgzNjg2NTU2fDA&ixlib=rb-4.1.0&q=85",
        galleryImages: [
            "https://images.unsplash.com/photo-1773842298512-e49c9331cc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxoYW5kbWFkZSUyMHJ1Z3MlMjB3b3Jrc2hvcCUyMGFydGlzYW58ZW58MHx8fHwxNzgzNjg2NTU2fDA&ixlib=rb-4.1.0&q=85",
            "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1200&q=80",
            "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80",
        ],
        subCategories: [
            "products.categories.rugs.subCategories.handKnotted",
            "products.categories.rugs.subCategories.handTufted",
            "products.categories.rugs.subCategories.flatWeave",
            "products.categories.rugs.subCategories.wool",
            "products.categories.rugs.subCategories.cotton",
            "products.categories.rugs.subCategories.silk",
            "products.categories.rugs.subCategories.jute",
            "products.categories.rugs.subCategories.outdoor",
            "products.categories.rugs.subCategories.traditional",
            "products.categories.rugs.subCategories.modern",
            "products.categories.rugs.subCategories.designer",
        ],
        specs: [
            { labelKey: "products.categories.rugs.specs.techniques.label", valueKey: "products.categories.rugs.specs.techniques.value" },
            { labelKey: "products.categories.rugs.specs.materials.label", valueKey: "products.categories.rugs.specs.materials.value" },
            { labelKey: "products.categories.rugs.specs.sizes.label", valueKey: "products.categories.rugs.specs.sizes.value" },
            { labelKey: "products.categories.rugs.specs.moq.label", valueKey: "products.categories.rugs.specs.moq.value" },
            { labelKey: "products.categories.rugs.specs.leadTime.label", valueKey: "products.categories.rugs.specs.leadTime.value" },
            { labelKey: "products.categories.rugs.specs.certifications.label", valueKey: "products.categories.rugs.specs.certifications.value" },
        ],
        oem: true,
        privateLabel: true,
    },
    {
        slug: "uniform-fabrics",
        nameKey: "products.categories.uniformFabrics.name",
        taglineKey: "products.categories.uniformFabrics.tagline",
        descriptionKey: "products.categories.uniformFabrics.description",
        image: "https://images.unsplash.com/photo-1593250816874-8edf4f732edb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHx1bmlmb3JtJTIwZmFicmljcyUyMHRleHRpbGUlMjByb2xsc3xlbnwwfHx8fDE3ODM2ODY1NTd8MA&ixlib=rb-4.1.0&q=85",
        galleryImages: [
            "https://images.unsplash.com/photo-1593250816874-8edf4f732edb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHx1bmlmb3JtJTIwZmFicmljcyUyMHRleHRpbGUlMjByb2xsc3xlbnwwfHx8fDE3ODM2ODY1NTd8MA&ixlib=rb-4.1.0&q=85",
            "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1200&q=80",
            "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80",
        ],
        subCategories: [
            "products.categories.uniformFabrics.subCategories.school",
            "products.categories.uniformFabrics.subCategories.corporate",
            "products.categories.uniformFabrics.subCategories.hospital",
            "products.categories.uniformFabrics.subCategories.industrial",
            "products.categories.uniformFabrics.subCategories.hotel",
            "products.categories.uniformFabrics.subCategories.security",
            "products.categories.uniformFabrics.subCategories.general",
        ],
        specs: [
            { labelKey: "products.categories.uniformFabrics.specs.composition.label", valueKey: "products.categories.uniformFabrics.specs.composition.value" },
            { labelKey: "products.categories.uniformFabrics.specs.gsm.label", valueKey: "products.categories.uniformFabrics.specs.gsm.value" },
            { labelKey: "products.categories.uniformFabrics.specs.widths.label", valueKey: "products.categories.uniformFabrics.specs.widths.value" },
            { labelKey: "products.categories.uniformFabrics.specs.moq.label", valueKey: "products.categories.uniformFabrics.specs.moq.value" },
            { labelKey: "products.categories.uniformFabrics.specs.leadTime.label", valueKey: "products.categories.uniformFabrics.specs.leadTime.value" },
        ],
        oem: true,
        privateLabel: false,
    },
    {
        slug: "safety-products",
        nameKey: "products.categories.safetyProducts.name",
        taglineKey: "products.categories.safetyProducts.tagline",
        descriptionKey: "products.categories.safetyProducts.description",
        image: "https://images.pexels.com/photos/8487719/pexels-photo-8487719.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        galleryImages: [
            "https://images.pexels.com/photos/8487719/pexels-photo-8487719.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=1200&q=80",
            "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=1200&q=80",
        ],
        subCategories: [
            "products.categories.safetyProducts.subCategories.coveralls",
            "products.categories.safetyProducts.subCategories.frCoveralls",
            "products.categories.safetyProducts.subCategories.boilerSuits",
            "products.categories.safetyProducts.subCategories.reflectiveJackets",
            "products.categories.safetyProducts.subCategories.safetyVests",
            "products.categories.safetyProducts.subCategories.safetyHelmets",
            "products.categories.safetyProducts.subCategories.safetyGloves",
            "products.categories.safetyProducts.subCategories.safetyShoes",
            "products.categories.safetyProducts.subCategories.safetyGoggles",
            "products.categories.safetyProducts.subCategories.earProtection",
            "products.categories.safetyProducts.subCategories.harnesses",
            "products.categories.safetyProducts.subCategories.rainwear",
        ],
        specs: [
            { labelKey: "products.categories.safetyProducts.specs.standards.label", valueKey: "products.categories.safetyProducts.specs.standards.value" },
            { labelKey: "products.categories.safetyProducts.specs.fabric.label", valueKey: "products.categories.safetyProducts.specs.fabric.value" },
            { labelKey: "products.categories.safetyProducts.specs.moq.label", valueKey: "products.categories.safetyProducts.specs.moq.value" },
            { labelKey: "products.categories.safetyProducts.specs.leadTime.label", valueKey: "products.categories.safetyProducts.specs.leadTime.value" },
            { labelKey: "products.categories.safetyProducts.specs.branding.label", valueKey: "products.categories.safetyProducts.specs.branding.value" },
        ],
        oem: true,
        privateLabel: true,
    },
    {
        slug: "agro-products",
        nameKey: "products.categories.agroProducts.name",
        taglineKey: "products.categories.agroProducts.tagline",
        descriptionKey: "products.categories.agroProducts.description",
        image: "https://images.unsplash.com/photo-1723530923751-f9b769238666?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHx3aGVhdCUyMGdyYWlucyUyMGZhcm18ZW58MHx8fHwxNzgzNjg2NTY2fDA&ixlib=rb-4.1.0&q=85",
        galleryImages: [
            "https://images.unsplash.com/photo-1723530923751-f9b769238666?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHx3aGVhdCUyMGdyYWlucyUyMGZhcm18ZW58MHx8fHwxNzgzNjg2NTY2fDA&ixlib=rb-4.1.0&q=85",
            "https://images.unsplash.com/photo-1501004318641-b39e6451bec6?auto=format&fit=crop&w=1200&q=80",
            "https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=1200&q=80",
        ],
        subCategories: [
            "products.categories.agroProducts.subCategories.freshFruits",
            "products.categories.agroProducts.subCategories.freshVegetables",
            "products.categories.agroProducts.subCategories.rice",
            "products.categories.agroProducts.subCategories.spices",
            "products.categories.agroProducts.subCategories.pulses",
            "products.categories.agroProducts.subCategories.oilSeeds",
            "products.categories.agroProducts.subCategories.organicProducts",
        ],
        specs: [
            { labelKey: "products.categories.agroProducts.specs.origin.label", valueKey: "products.categories.agroProducts.specs.origin.value" },
            { labelKey: "products.categories.agroProducts.specs.packing.label", valueKey: "products.categories.agroProducts.specs.packing.value" },
            { labelKey: "products.categories.agroProducts.specs.moq.label", valueKey: "products.categories.agroProducts.specs.moq.value" },
            { labelKey: "products.categories.agroProducts.specs.certifications.label", valueKey: "products.categories.agroProducts.specs.certifications.value" },
            { labelKey: "products.categories.agroProducts.specs.leadTime.label", valueKey: "products.categories.agroProducts.specs.leadTime.value" },
        ],
        oem: true,
        privateLabel: true,
    },
];

export const getCategory = (slug) =>
    productCategories.find((c) => c.slug === slug);
